(function(Backbone, _, $) {

  // Use strict mode.
  'use strict';

  /**
   * Menu handler.
   */
  const MenuView = Backbone.View.extend({
    active: false,
    el: "#site-header .menu--main",
    $drawer: null,
    events: {
      'click >.menu>.menu-item--expanded>a': '_click',
      'click >.menu>.menu-item--expanded>span': '_click',
    },

    initialize: function(options) {
      _.bindAll(this, '_click');
      $('html').addClass('js-menu');
      this.$drawer = $('#menu-drawer');
    },

    render: function() {
    },

    _click: function(e) {
      e.preventDefault();

      // first check if mobile nav menu is open
      if ($('#site-header .mobile-nav:visible')[0]) {
        return;
      }

      var view = this;
      var $drawer = view.$drawer;
      var $p = $(e.currentTarget).parent();
      view.$el.find('.js-active').not($p).removeClass('js-active');

      if ($p.hasClass('js-active')) {
        $p.removeClass('js-active');
        $drawer.removeClass('active').slideUp(250);
      }
      else {
        $p.addClass('js-active');
        // determine min height
        var h = $(window).height()-$drawer.offset().top;

        // get background
        var $bg = $p.find('figure.bg').first();
        var bg = $bg[0] ? $bg.css('background-image') : '';
        $drawer.css('background-image',bg);

        // swap out contents
        if ($drawer.hasClass('active')) {
          var $wrap = $drawer.find('.outer-wrapper');
          $wrap.find('>.menu').slideUp(150, function() {
            $(this).remove();
            var $ul = $('<ul class="menu">'+$p.find('.menu').clone().html()+'</ul>').hide();
            $wrap.html($ul);
            $ul.slideDown(250);
          });

          // slide down new drawer
        }
        else {
          $drawer.hide().html('<div class="outer-wrapper" style="min-height:'+h+'px;"><ul class="menu">'+$p.find('.menu').clone().html()+'</ul></div>').addClass('active').slideDown(250);
        }
      }
    }

  });

  const menu = new MenuView();


})(Backbone, _, jQuery);
